export class Promotion {
  name!: string
  startDate!: string
  endDate!: string
  forecastingMethodId!: string
  marginCredit!: string
  salePrice!: string
  productId!: string
  accountIds!: string
  promotionProductAccount: any = []
  description!: string
  accountName: any = [];
  upcCodelist!: any
  cost!: string
  active!: any
  product!: any
  promoNumber!: any
  promoEventType!: any
  miscEventDetails!: any
  offerType!: any
  programName!: any
  status!: any
  promocomments!: any
  discountCost!: any
  msrp!: any
  currency!: any
  discountPercent!: any
  activeAccount!: any
  stackable!: any
  promoPrice!: string
}
